const angular = require('angular');

angular.module('wowApp.common')
    .directive('wowNameLengthWarnings', require('./name-length-warnings.directive'));



// WEBPACK FOOTER //
// ./src/common/namelengthwarnings/index.js